// Admin Hub CUSTOMER-level classification. Lowercase values are what the Hub
// stores and what REACH sends. Customer Industry is NEVER the awarded service
// ("janitorial" is a service being sold, not a customer industry).
export const HUB_TYPE_LABELS = {
  commercial: "Commercial",
  financial: "Financial",
  education: "Education",
  retail: "Retail",
  healthcare: "Healthcare",
};

export const HUB_INDUSTRY_LABELS = {
  office: "Office",
  banking: "Banking",
  education: "Education",
  retail: "Retail",
  healthcare: "Healthcare",
};

// Compatible Type -> Industry pairs (enforced in UI and backend).
export const HUB_TYPE_INDUSTRY = {
  commercial: "office",
  financial: "banking",
  education: "education",
  retail: "retail",
  healthcare: "healthcare",
};
